const getShapeFromLocalMap = (branch, zoomLevel, targetId)=>{
   let mapToGet;
   switch(zoomLevel){
      case 0: 
      case 1: 
         mapToGet = 'circoscrizioni'; 
         break;
      case 2: 
         mapToGet = 'regioni'; 
         break;
      case 3: 
      default: mapToGet = 'circoscrizioni'; break;
   }
   const mapRecords = JSON.parse(localStorage.getItem(`ep19-${mapToGet}-${branch}`));
   const out = mapRecords.mapData.filter((el)=>el.shapeId == targetId)[0];
   return out ? out : null
}
export default getShapeFromLocalMap;



// WEBPACK FOOTER //
// ./src/utils/getShapeFromLocalMap.js